import React from "react";

export default function Icon({ source, color, span }) {
    return (
        <div className={`icon-container ${color}`}>
            <i className={source}></i>
            {span && <span>{span}</span>}
        </div>
    );
}
